

import * as types from "./actionTypes";
import * as enrolleeApi from "../../_api/enrolleeApi";
import Cookies from "universal-cookie";
import { beginApiCall, apiCallError } from "./apiStatusActions";
import { utilities } from "@/_helpers";
import { refreshEnrolleeToken } from "@/_helpers/enrolleeAuthHelper";

const cookies = new Cookies();
const posthogIdPattern = /^[A-Za-z0-9-]+$/;

function addPosthogIdFromEnrollmentCookie(payload) {
  if (!payload || typeof payload !== "object") return payload;

  const enrollNowCookie = cookies.get("EnrollNow") || {};
  const posthogId = payload.posthog_id ?? enrollNowCookie.posthog_id;
  const updatedPayload = { ...payload };

  if (typeof posthogId === "string" && posthogIdPattern.test(posthogId)) {
    updatedPayload.posthog_id = posthogId;
  } else {
    delete updatedPayload.posthog_id;
  }

  return updatedPayload;
}

function normalizeCountryInPayload(payload) {
  if (!payload || typeof payload !== "object") return payload;
  if (!Object.prototype.hasOwnProperty.call(payload, "country")) return payload;

  return {
    ...payload,
    country: utilities.normalizeCountryForPlus(payload.country, "USA"),
  };
}

export function enrolleeLoginSuccess() {
  return { type: types.ENROLLEE_LOGIN_SUCCESS };
}

export function enrolleeLogoutSuccess() {
  return { type: types.ENROLLEE_LOGOUT_SUCCESS };
}

// Update Enrollee is in between full API Saves which updates the state of the Enrollee Object
export function enrolleeUpdateSuccess(enrollee) {
  return { type: types.ENROLLEE_UPDATE_SUCCESS, enrollee };
}

export function clientUpdateSuccess(enrollee) {
  return { type: types.CLIENT_UPDATE_SUCCESS, enrollee };
}

export function enrolleeScheduleSucess() {
  return { type: types.ENROLLEE_SCHEDULE_SUCCESS };
}

export function updateEnrollee(enrollee) {
  return function (dispatch) {
    dispatch(enrolleeUpdateSuccess(enrollee));
  };
}

export function loadEnrollee(ClientID, UserID) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return enrolleeApi
      .getEnrollee(ClientID, UserID)
      .then((enrollee) => {
        return enrollee;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function validateEnrollmentCode(EnrollmentCode, BrandIdentifier) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return enrolleeApi
      .validateEnrollmentCode(EnrollmentCode, BrandIdentifier)
      .then((enrollee) => {
        return enrollee;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function saveEnrollee(saveObj) {
  return function (dispatch, getState) {
    dispatch(beginApiCall());
    const normalizedSaveObj = normalizeCountryInPayload(saveObj);
    return enrolleeApi
      .clientSave(normalizedSaveObj)
      .then(async (returnObj) => {
        const refreshedEnrollee = await refreshEnrolleeToken();
        const jwtToken =
          refreshedEnrollee?.jwtToken || refreshedEnrollee?.JWTToken;
        const refreshToken =
          refreshedEnrollee?.refreshToken || refreshedEnrollee?.RefreshToken;

        const refreshedTokens =
          jwtToken && refreshToken
            ? {
                jwtToken,
                JWTToken: jwtToken,
                refreshToken,
                RefreshToken: refreshToken,
              }
            : {};

        if (jwtToken && refreshToken) {
          dispatch(
            enrolleeUpdateSuccess({
              ...getState().enrollee,
              ...refreshedTokens,
            }),
          );
        }

        return { ...returnObj, ...refreshedTokens };
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function clientUpdate(updateObj, options = {}) {
  return function (dispatch) {
    dispatch(beginApiCall());
    const normalizedUpdateObj = normalizeCountryInPayload(updateObj);
    return enrolleeApi
      .updateClient(normalizedUpdateObj)
      .then(() => {
        if (options.skipEnrolleeUpdate) {
          dispatch(clientUpdateSuccess(normalizedUpdateObj));
          return undefined;
        }
        const enrolleeUpdateObj = addPosthogIdFromEnrollmentCookie(normalizedUpdateObj);
        return enrolleeApi.updateEnrollee(enrolleeUpdateObj).then(() => {
          // dispatch(clientUpdateSuccess(normalizedUpdateObj));
          dispatch(clientUpdateSuccess(enrolleeUpdateObj));
        });
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function enrolleeUpdate(updateObj) {
  return function (dispatch) {
    dispatch(beginApiCall());
    const enrolleeUpdateObj = addPosthogIdFromEnrollmentCookie(updateObj);
    return enrolleeApi.updateEnrollee(enrolleeUpdateObj).catch((error) => {
      dispatch(apiCallError(error));
      throw error;
    });
  };
}

export function scheduleEnrollee(scheduleInfo) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return enrolleeApi
      .scheduleEnrollee(scheduleInfo)
      .then(() => {
        dispatch(enrolleeScheduleSucess());
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function enrolleeOptIn(optInObj) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return enrolleeApi.textOptIn(optInObj).catch((error) => {
      dispatch(apiCallError(error));
      throw error;
    });
  };
}

export function registerEnrollee(obj) {
  return function (dispatch) {
    dispatch(beginApiCall());
    const enrolleeObj = addPosthogIdFromEnrollmentCookie(obj);
    return enrolleeApi
      .registerEnrollee(enrolleeObj)
      .then((returnObj) => {
        return returnObj;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}
export function loadClientCheck(
  FirstName,
  LastName,
  CellPhone,
  Email,
  BrandIdentifier,
) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return enrolleeApi
      .getClientCheck(FirstName, LastName, CellPhone, Email, BrandIdentifier)
      .then((clientCheck) => {
        return clientCheck;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function clientCheck(clientObj) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return enrolleeApi
      .clientCheck(clientObj)
      .then((returnObj) => {
        return returnObj;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function validateCode(enrollmentCode, brandIdentifier) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return enrolleeApi
      .validateCode(enrollmentCode, brandIdentifier)
      .then((returnObj) => {
        return returnObj;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function clientProfiles(clientId) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return enrolleeApi
      .clientProfiles(clientId)
      .then((returnObj) => {
        return returnObj;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function five9Text(clientObj) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return enrolleeApi
      .five9Text(clientObj)
      .then((returnObj) => {
        return returnObj;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function generatePriceQuote(quoteObj) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return enrolleeApi
      .generatePriceQuote(quoteObj)
      .then((returnObj) => {
        return returnObj;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function getPriceQuoteDetails(priceQuoteGuid) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return enrolleeApi
      .getPriceQuoteDetails(priceQuoteGuid)
      .then((returnObj) => {
        return returnObj;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function saveClientQuestionResponse(questionObj) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return enrolleeApi
      .saveClientQuestionResponse(questionObj)
      .then((returnObj) => {
        return returnObj;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function loadClientQuestionResponse(clientId) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return enrolleeApi
      .getClientQuestionResponse(clientId)
      .then((returnObj) => {
        return returnObj;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function loadIsaEnrollmentCodeByState(State, BrandIdentifier) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return enrolleeApi
      .getIsaEnrollmentCodeByState(State, BrandIdentifier)
      .then((returnObj) => {
        return returnObj;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function pickBackUpEnrollment(tokenId, brandIdentifier) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return enrolleeApi
      .pickBackUpEnrollment(tokenId, brandIdentifier)
      .then((returnObj) => {
        return returnObj;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function GetQuietHours(clientId) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return enrolleeApi
      .quietHours(clientId)
      .then((returnObj) => {
        return returnObj;
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}
